module.exports = __webpack_public_path__ + "img/essential-apps.f9b6984d.svg";